import { useEffect } from "react"
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"
import { $isHeadingNode } from "@lexical/rich-text"
import {
  $createParagraphNode,
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_LOW,
  KEY_ENTER_COMMAND,
  TextFormatType,
} from "lexical"

// Pull this list from the union type here
// https://github.com/facebook/lexical/blob/main/packages/lexical/src/nodes/LexicalTextNode.ts#L89-L100
const ALL_TEXT_FORMATS: TextFormatType[] = [
  "bold",
  "underline",
  "strikethrough",
  "italic",
  "highlight",
  "code",
  "subscript",
  "superscript",
  "lowercase",
  "uppercase",
  "capitalize",
]

export default function ClearFormattingOnNewBlockPlugin() {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    return editor.registerCommand(
      KEY_ENTER_COMMAND,
      () => {
        setTimeout(() => {
          editor.update(() => {
            const selection = $getSelection()
            if ($isRangeSelection(selection)) {
              for (const format of ALL_TEXT_FORMATS) {
                if (selection.hasFormat(format)) {
                  selection.toggleFormat(format)
                }
              }

              const topLevelNode = selection.anchor.getNode().getTopLevelElement()
              if (topLevelNode && $isHeadingNode(topLevelNode) && topLevelNode.getTextContent() === "") {
                const paragraph = $createParagraphNode()
                topLevelNode.replace(paragraph)
                paragraph.select()
              }
            }
          })
        }, 0)
        return false
      },
      COMMAND_PRIORITY_LOW
    )
  }, [editor])

  return null
}
